export const OMITTED_STR = '***';
